export class Themes {
  static light = 'light-theme';
  static dark = 'dark-theme';
}